<!-- see https://kazupon.github.io/vue-i18n/guide/component.html#shared-locale-messages-for-components -->
<i18n src="@/translations/FinMyPortfolios.json"></i18n>

<template>
  <fin-content-section container-class="py-8"
                       icon="icon-myfinhub"
                       :title="sectionTitle">
    <!--template #afterTitle>
      <fin-realtime-indicator class="ml-1" trading-platform="tradegate"/>
    </template-->

    <template #actions>
      <v-btn style="float: right;"
             text
             :loading="charts===null"
             @click="createPortfolioDialog">
        <fin-subscription-lock v-if="maxPortfolios && portfolioCount >= maxPortfolios" color="fin-color-primary-dark"/>
        <v-icon v-else>icon-plus</v-icon>
        Neues anlegen
      </v-btn>
      <v-btn v-if="!isMobileOrTabletOrApp"
             style="float: right;"
             id="finhub-import-portfolio-button"
             text
             :loading="charts===null"
             @click="importPortfolioDialog">
        <fin-subscription-lock v-if="maxPortfolios && portfolioCount >= maxPortfolios" color="fin-color-primary-dark"/>
        <v-icon v-else>mdi-upload</v-icon>
        Portfolio hochladen
      </v-btn>
    </template>

    <fin-create-portfolio-dialog v-model="showDialogCreatePortfolio"
                                 :loading="createPortfolioInProcess"
                                 @confirm="createPortfolio"/>

    <fin-create-portfolio-dialog v-model="showDialogImportPortfolio"
                                 :loading="createPortfolioInProcess"
                                 :message-details="messageDetails"
                                 :currentStatus="currentStatus"
                                 :error-msg="customErrorMsg"
                                 :new-portfolio-id="newPortfolioId"
                                 mode-import
                                 @statusChanged="newStatus => currentStatus = newStatus"
                                 @confirm="importAndCreatePortfolio"/>

    <fin-chart-list ref="portfolios"
                    @input="chartsLoaded"
                    @selectedItem="selectedChartChange"
                    @changeItemStatus="statusObj => changePortfolioStatus(statusObj)"
                    @deleteItem="pfId => deletePortfolio(pfId)"
                    :no-preview="$vuetify.breakpoint.xsOnly"
                    :data-loader-params="{selectedGroup: groups[selectedGroup]}"
                    :items="items">
      <template #aboveChartActions>
        <fin-tabs :selected-tab="selectedGroup" :tab-items="groups" @tabChanged="tab => tabChanged(tab)"
                  no-tab-padding no-item-title-padding background-color-tabs="transparent"
                  class="mb-3 portfolios-wrapper-tabs"
        />
      </template>

      <template #noData>
        <fin-no-portfolio-yet @showPortfolioDialog="createPortfolioDialogNoPortfolioYet"/>
      </template>

      <template #card-actions="{item}">
        <v-btn :disabled="item.inactiveItem"
               :to="{ name: 'portfolioDetail', params: { id: item.id }}"
               class="mt-1 more"
               color="white"
               elevation="0"
               @click.native="toPortfolioClicked">
          Zum Portfolio
        </v-btn>
        <v-spacer v-if="$vuetify.breakpoint.smAndDown"/>

        <div class="mt-1" style="text-align: right; display: inline-flex; position: absolute; right: 0;">
          <v-icon v-if="hasInactivePortfolios && !item.inactiveItem"
                  class="mb-1"
                  @click="changePortfolioStatusConfirm(item.id, item.title,true)">
            mdi-lock-open-variant
          </v-icon>
          <v-icon v-else-if="hasInactivePortfolios && item.inactiveItem"
                  :color="$finColors.accentRed"
                  class="mb-1"
                  @click="changePortfolioStatusConfirm(item.id, item.title,false)">
            mdi-lock
          </v-icon>

          <v-icon v-if="!isMobileOrTabletOrApp"
                  class="ml-3"
                  @click="exportPortfolio(item.id, item.title)">
            mdi-download
          </v-icon>

          <v-icon class="ml-3"
                  @click="deletePortfolioConfirm(item.id, item.title)">
            icon-delete
          </v-icon>
        </div>
      </template>

      <template #small-chart-actions="{item}">
        <v-icon v-if="hasInactivePortfolios && !item.inactiveItem"
                class="mb-1"
                @click.stop="changePortfolioStatusConfirm(item.id, item.title,true)">
          mdi-lock-open-variant
        </v-icon>
        <v-icon v-else-if="hasInactivePortfolios && item.inactiveItem"
                :color="$finColors.accentRed"
                class="mb-1"
                @click.stop="changePortfolioStatusConfirm(item.id, item.title,false)">
          mdi-lock
        </v-icon>

        <v-icon v-if="$vuetify.breakpoint.mdAndUp && !isMobileOrTabletOrApp"
                class="ml-3"
                @click.stop="exportPortfolio(item.id, item.title)">
          mdi-download
        </v-icon>
        <v-icon v-if="$vuetify.breakpoint.mdAndUp"
                class="ml-3"
                @click.stop="deletePortfolioConfirm(item.id, item.title)">
          icon-delete
        </v-icon>
      </template>
    </fin-chart-list>
  </fin-content-section>
</template>

<script>
import FinNoPortfolioYet from "./NoPortfolioYet"
import FinChartList from "@/components/common/Chart2/PerformanceCharts/ChartList"
import {API, graphqlOperation, Storage} from "@/plugins/finAmplifyModules"
import {mapActions, mapGetters} from "vuex"
import FinChartBuilder from "@/components/common/Chart2/FinChartBuilder"
import FinContentSection from "@/components/pages/ContentSection"
import FinCreatePortfolioDialog from "@/components/common/portfolio/CreatePortfolioDialog"
import {finPortfolioAPI} from "@/js/finAPI"
import {recalculatePortfolio} from "@/components/pages/myFinHub/finPortfolios/graphql"
import {onUpdatePortfolioRealTimeChange} from "@/js/finSubscriptions"
import finBrowser from "@/js/finBrowser"
import {
  COMPAREQUERIES_REALTIME,
  getSeries,
  seriesId,
  createPortfolioRealTimeSubcription, selectCompareExtreme, updateRebaseButton
} from "@/components/common/Chart2/CompareChart"
import {ERROR_TYPE, handleError} from '@/js/errorhandler/finAWSErrorHandler'
import PriceModel from "@/mixins/PriceModel"
import {PRICEMODEL_FEATURE_IDS, PRICEMODEL_FEATURE_RESTRICTIONS} from "@/js/finPriceModel"
import {EventBus} from "@/plugins/fincraft"
import {exportPortfolio, itemInactiveStatus} from "@/js/finMutations"
import FinTabs from "@/components/common/Tabs"
import AmplitudePush from "@/mixins/AmplitudePush"
import FinSubscriptionLock from "@/components/common/subscription/lock"


const STATUS_INITIAL = 0, STATUS_SAVING = 1, STATUS_SUCCESS = 2, STATUS_FAILED = 3

// loads all portfolios but without details
const queryList = `
query listPortfoliosByOwner($owner : String!) {
  listPortfoliosByOwner(owner: $owner, sortDirection: DESC, inclInactive: true) {
   items {
      id
      name
      inactive
      preview: timeSeries1M(assetClass:"TOTAL"){
        y: result
        x: timestamp
        curr:currentValue
      }
      realtime: timeSeriesRT(assetClass:"TOTAL"){
        y:result
        x:timestamp
        curr:currentValue
      }
    }
  }
}
`

const queryListPerformance = `
query listPortfoliosByOwner( $owner : String! ) {
  listPortfoliosByOwner(owner: $owner, sortDirection: DESC, inclInactive: true) {
   items {
      id
      name
      inactive
      preview: timeSeries1M(assetClass:"TOTAL"){
        y: yield
        x: timestamp
        curr:currentValue
      }
      realtime: timeSeriesRT(assetClass:"TOTAL"){
        y:yield
        x:timestamp
        curr:currentValue
      }
    }
  }
}
`

//Loads all details for the detailview
const queryDetail = `
  query GetPortfolio($id: ID!) {
    getPortfolio(id: $id) {
      id
      name
      inactive
      timeSeries: timeSeries(assetClass:"TOTAL"){
        y:result
        x:timestamp
        curr:currentValue
      }
      realtime: timeSeriesRT(assetClass:"TOTAL"){
        y:result
        x:timestamp
        curr:currentValue
      }
    }
  }
`

function placeholderChart(chart) {
  chart = {
    lang: {
      noData: ""
    }
  }
  chart.series = null
  return chart
}

export default {
  name: 'FinMyPortfolios',
  components: {
    FinSubscriptionLock,
    FinTabs,
    FinCreatePortfolioDialog,
    FinContentSection,
    FinChartList,
    FinNoPortfolioYet,
  },
  data: () => ({
    selectedGroup: 0,
    showDialogCreatePortfolio: false,
    showDialogImportPortfolio: false,
    createPortfolioInProcess: false,
    charts: null,
    currentStatus: null,
    customErrorMsg: null,
    messageDetails: [],
    groups: [{name: 'Performance', offset: 0}, {name: 'Gewinn', offset: 1}],
    portfolioCount: 0,
    portfolios: [],
    newPortfolioId: null,
    isMobileOrTabletOrApp: finBrowser.IS_MOBILE_OR_TABLET || finBrowser.IS_IOS_OR_ANDROID_APP,
  }),
  mixins: [AmplitudePush, PriceModel],
  computed: {
    ...mapGetters('auth', ['userId', 'showOnBoarding', 'userOnboardingData']),
    maxPortfolios() {
      return this.priceModelEnabledAndLimit(PRICEMODEL_FEATURE_IDS.PORTFOLIO.id)
    },
    hasInactivePortfolios() {
      return this.portfolios.find(p => p.inactive === true) !== undefined
    },
    sectionTitle() {
      let title = 'Deine Portfolios'

      if (this.portfolioCount > this.maxPortfolios) {
        title += '<span style="color: ' + this.$finColors.accentRed + '">'
      }

      title += '&nbsp;(' + this.portfolioCount + ' von ' + (this.maxPortfolios ? this.maxPortfolios : '-') + ')'

      if (this.portfolioCount > this.maxPortfolios) {
        title += '</span>'
      }

      return title
    },
  },
  methods: {
    ...mapActions('auth', ['updateOnboarding']),
    ...mapGetters('auth', ['profile']),
    chartsLoaded(charts) {
      this.charts = charts
    },
    async items(params) {
      //TODO improve only to one calculation
      const text = params?.selectedGroup?.name
      if (text !== 'Performance') {
        return {
          load: graphqlOperation(queryList, {owner: this.userId}),
          adapt: ({listPortfoliosByOwner: data}) => {
            data.items.sort((a, b) => {
              return !!a.inactive === !!b.inactive ? 0 : a.inactive ? 1 : -1
            })
            this.portfolios = data.items ? data.items : []
            this.portfolioCount = this.portfolios.length

            const result = data.items.map(item => {
              const timeseries = [...item.preview, ...item.realtime]
              const previewData = FinChartBuilder.mapTimeSeriesPoint(timeseries, 'y', 'x', true)
              const previewChart = FinChartBuilder.createPerformanceChart('Performance', previewData, 'small',
                this.$vuetify.breakpoint, false, '€', false, false, true, 2)

              //helper just in case a subscription arrives to the mini chart while loading the big
              let lastpoint = null

              // only create subscriptions for active portfolios
              if (!item.inactive) {
                previewChart.subscriptions = [
                  {
                    subscription: graphqlOperation(onUpdatePortfolioRealTimeChange, {id: item.id, owner: this.userId}),
                    async trigger({data}, {chart}) {
                      const recalcPortf = data.onUpdatePortfolioRealTimeChange
                      if (recalcPortf) {
                        const {id} = recalcPortf
                        if (id !== item.id) {
                          //check if this happens and how
                          return
                        }
                        const calcResultRequest = await API.graphql(graphqlOperation(recalculatePortfolio, {
                          portfolioId: id,
                          assetClass: 'TOTAL'
                        }))
                        const calcResult = calcResultRequest.data.getPortfolioRatioDataRealTime

                        if (calcResult) {
                          lastpoint = {
                            curr: calcResult.currentValue,
                            x: new Date(calcResult.timestamp).getTime(),
                            y: calcResult.result
                          }
                          chart.series[0].addPoint(lastpoint, true, false)
                          previewData.push(lastpoint)
                          const {min} = chart.xAxis[0].getExtremes()
                          chart.xAxis[0].setExtremes(min, lastpoint.x, true, true, {trigger: 'addPoint'})
                        }
                      }
                    }
                  }
                ]
              }

              return {
                id: item.id,
                highlightCard: true,
                title: item.name,
                hidePercentageChange: true,
                currentValueUseSemanticColors: true,
                currentValueTitle: 'Lade...',
                prependPerformanceText: ' ',
                inactiveItem: item.inactive,
                to: {name: 'portfolioDetail', params: {id: item.id}},
                chart:
                  {
                    init: () => {
                      const chart = FinChartBuilder.createPerformanceChart('Gewinn', previewData, 'big',
                        this.$vuetify.breakpoint, false, '€', false, false, false, 2)
                      chart.series[0].id = seriesId(item.id)
                      return chart
                    },
                    load: () => graphqlOperation(queryDetail, {id: item.id}),
                    adapt: ({getPortfolio: detailData}) => {

                      const seriesDetailData = FinChartBuilder.mapTimeSeriesPoint([...detailData.timeSeries, ...detailData.realtime], 'y', 'x', true)

                      if (lastpoint) {
                        const checklLast = seriesDetailData[seriesDetailData.length - 1]
                        if (lastpoint.x > checklLast.x) {
                          //subscription arrived while loading
                          seriesDetailData.push(lastpoint)
                        }
                      }

                      const chart = FinChartBuilder.createPerformanceChart('Gewinn', seriesDetailData, 'big',
                        this.$vuetify.breakpoint, false, '€', false, false, false, 2)
                      chart.series[0].id = seriesId(item.id)
                      chart.tradingPlatform = 'tradegate'
                      chart.currentValueTitle = 'Gewinn seit Start'
                      chart.prependPerformanceText = 'Gewinn seit'
                      chart.plotOptions = {
                        series: {
                          compare: 'none',
                        }
                      }

                      // only create subscriptions for active portfolios
                      if (!item.inactive) {
                        chart.subscriptions = [
                          createPortfolioRealTimeSubcription(item.id, this.userId, false)
                        ]
                      }

                      return chart
                    },
                  },
                previewChart
              }
            })
            return result
          }
        }
      } else {
        return {
          load: graphqlOperation(queryListPerformance, {owner: this.userId}),
          adapt: ({listPortfoliosByOwner: data}) => {
            data.items.sort((a, b) => {
              return !!a.inactive === !!b.inactive ? 0 : a.inactive ? 1 : -1
            })
            this.portfolios = data.items ? data.items : []
            this.portfolioCount = this.portfolios.length
            const result = data.items.map(item => {
              const timeseries = [...item.preview, ...item.realtime]
              timeseries.forEach(item => {
                  if (item.y === null) {
                    item.y = 0
                  }
                }
              )
              const previewData = FinChartBuilder.mapTimeSeriesPoint(timeseries, 'y', 'x', true)
              const previewChart = FinChartBuilder.createPerformanceChart('Performance', previewData, 'small',
                this.$vuetify.breakpoint, false, '€', false, false, true, 2)

              previewChart.tooltip.performanceSuffix = '%'
              //helper just in case a subscription arrives to the mini chart while loading the big
              let lastpoint = null

              if (!item.inactive) {
                previewChart.subscriptions = [
                  {
                    subscription: graphqlOperation(onUpdatePortfolioRealTimeChange, {id: item.id, owner: this.userId}),
                    async trigger({data}, {chart}) {
                      const recalcPortf = data.onUpdatePortfolioRealTimeChange
                      if (recalcPortf) {
                        const {id} = recalcPortf
                        if (id !== item.id) {
                          //check if this happens and how
                          return
                        }
                        const calcResultRequest = await API.graphql(graphqlOperation(recalculatePortfolio, {
                          portfolioId: id,
                          assetClass: 'TOTAL'
                        }))
                        const calcResult = calcResultRequest.data.getPortfolioRatioDataRealTime

                        if (calcResult) {
                          lastpoint = {
                            curr: calcResult.currentValue,
                            x: new Date(calcResult.timestamp).getTime(),
                            y: calcResult.yield === null ? 0 : calcResult.yield
                          }
                          chart.series[0].addPoint(lastpoint, true, false)
                          previewData.push(lastpoint)
                          const {min} = chart.xAxis[0].getExtremes()
                          chart.xAxis[0].setExtremes(min, lastpoint.x, true, true, {trigger: 'addPoint'})
                        }
                      }
                    }
                  }
                ]
              }
              return {
                id: item.id,
                title: item.name,
                highlightCard: true,
                hidePercentageChange: true,
                currentValueUseSemanticColors: true,
                currentValueTitle: 'Lade...',
                prependPerformanceText: ' ',
                compareTitle: this.$vuetify.breakpoint.xsOnly ? 'Auswahl' : 'Lege fest, womit du dein Portfolio vergleichen möchtest',
                inactiveItem: item.inactive,
                to: {name: 'portfolioDetail', params: {id: item.id}},
                chart:
                  {
                    init: () => {
                      const chart = FinChartBuilder.createPerformanceChart('Performance', previewData, 'big',
                        this.$vuetify.breakpoint, false, '%', false, false, false, 2)
                      chart.series[0].id = seriesId(item.id)
                      chart.finCompare = {}
                      return chart
                    },
                    load: () => graphqlOperation(COMPAREQUERIES_REALTIME.PORTFOLIO, {id: item.id}),
                    adapt: ({getPortfolio: detailData}) => {
                      const timeseries = [...detailData.timeSeries, ...detailData.realtime]
                      timeseries.forEach(item => item.y = item.y + 100)
                      const seriesDetailData = FinChartBuilder.mapTimeSeriesPoint(timeseries, 'y', 'x', true)

                      const chart = FinChartBuilder.createPerformanceChart(item.name, seriesDetailData, 'big',
                        this.$vuetify.breakpoint, false, '%', false, false, false, 2)
                      chart.series[0].id = seriesId(item.id)
                      chart.tradingPlatform = 'tradegate'
                      chart.currentValueTitle = 'Performance seit Start'
                      chart.prependPerformanceText = 'Performance seit'
                      chart.tooltip.pointFormat = `<span style="color:{series.color}">\u25CF</span> {series.name}: <b>{point.change}%</b>`
                      chart.currentValue = (val) => val - 100
                      chart.plotOptions = {
                        series: {
                          compare: 'percent',
                        },
                      }
                      chart.xAxis = {
                        events: {
                          afterSetExtremes: function (ev) {
                            let chart = this.chart
                            if (chart) {
                              updateRebaseButton(chart)
                            }
                          }
                        }
                      }

                      chart.finCompare = {
                        keepSelection: true,
                        select: async (chart, selected) => {
                          const series = await getSeries(this.userId, chart, selected)
                          if (!series) {
                            return '##ff0000'
                          }
                          const {color} = await chart.addSeries(series)
                          this.$nextTick(() => {
                            selectCompareExtreme(chart)
                          })
                          return color
                        },
                        selectAll: async (chart, selected) => {
                          const series = await Promise.all(selected.map(item => getSeries(this.userId, chart, item)))
                          series.forEach(item => chart.addSeries(item))
                        },
                        unselect: async (chart, selected) => {
                          //TODO remove subscription aswell
                          await chart.get(seriesId(selected.item.id)).remove()
                          this.$nextTick(() => {
                            selectCompareExtreme(chart)
                          })
                        },
                        excludePortfolioID: item.id
                      }

                      // only create subscriptions for active portfolios
                      if (!item.inactive) {
                        chart.subscriptions = [
                          createPortfolioRealTimeSubcription(item.id, this.userId, true)
                        ]
                      }
                      return chart
                    }
                  },
                previewChart
              }
            })
            return result
          }
        }
      }
    },
    toPortfolioClicked() {
      this.pushToAmplitude({
        'event': 'fincraft_finhub_portfolios_to_portfolio',
        'step': 'portfolio_details',
        'placement': 'finhub_portfolios',
        'vue_breakpoint': this.$vuetify.breakpoint.name
      })
    },
    selectedChartChange(selCard) {
      this.pushToAmplitude({
        'event': 'fincraft_finhub_portfolios_smallcard',
        'step': 'fincraft_finhub_portfolios_select',
        'step_choice': selCard ? this.charts.findIndex(chart => chart.id === selCard.id) : '',
        'placement': 'finhub_portfolios',
        'vue_breakpoint': this.$vuetify.breakpoint.name
      })
    },
    createPortfolioDialogNoPortfolioYet() {
      this.pushToAmplitude({
        'event': 'fincraft_finhub_portfolios_new',
        'step': 'new_portfolio',
        'placement': 'finhub_portfolios_no_portfolio_yet',
        'vue_breakpoint': this.$vuetify.breakpoint.name
      })
      this.showDialogCreatePortfolio = true
    },
    createPortfolioDialog() {
      if (this.maxPortfolios && this.portfolioCount >= this.maxPortfolios) {
        let newCount = this.portfolioCount
        EventBus.$emit('showSubscriptionPopup', PRICEMODEL_FEATURE_IDS.PORTFOLIO.id, PRICEMODEL_FEATURE_RESTRICTIONS.QUANTITY, {itemAmount: ++newCount})
      } else {
        this.pushToAmplitude({
          'event': 'fincraft_finhub_portfolios_new',
          'step': 'new_portfolio',
          'placement': 'finhub_portfolios',
          'vue_breakpoint': this.$vuetify.breakpoint.name
        })

        this.showDialogCreatePortfolio = true
      }
    },
    importPortfolioDialog() {
      if (this.isPriceModelFeatureEnabled(PRICEMODEL_FEATURE_IDS.PORTFOLIO_UPLOAD_DOWNLOAD.id) === false) {
        EventBus.$emit('showSubscriptionPopup', PRICEMODEL_FEATURE_IDS.PORTFOLIO_UPLOAD_DOWNLOAD.id, PRICEMODEL_FEATURE_RESTRICTIONS.UNAVAILABLE)
      } else if (this.maxPortfolios && this.portfolioCount >= this.maxPortfolios) {
        let newCount = this.portfolioCount
        EventBus.$emit('showSubscriptionPopup', PRICEMODEL_FEATURE_IDS.PORTFOLIO.id, PRICEMODEL_FEATURE_RESTRICTIONS.QUANTITY, {itemAmount: ++newCount})
      } else {
        this.pushToAmplitude({
          'event': 'fincraft_finhub_portfolios_import',
          'step': 'import_portfolio',
          'placement': 'finhub_portfolios',
          'vue_breakpoint': this.$vuetify.breakpoint.name
        })

        this.showDialogImportPortfolio = true
      }
    },
    async createPortfolio({name, capital}) {
      this.createPortfolioInProcess = true
      try {
        const created = await finPortfolioAPI.createPortfolio(name, capital, 0)
        const id = created.id

        // if the user hasn't finished the onboarding = cancelled + skipped process at fasttrack
        // => set initialOnboardingFinished (at next login the user isn't presented the fasttrack ui => Dashboard)
        if (this.showOnBoarding) {
          this.userOnboardingData.initialOnboardingFinished = true
          const jsonVal = JSON.stringify(this.userOnboardingData) || '{}'
          await this.updateOnboarding(jsonVal).catch(error => {
            console.error("Error setting initialOnboardingFinished after creating first portfolio", error)
          })
        }

        await this.$refs.portfolios.reload()
        this.$toasted.global.finToast({
          message: this.$t('FinMyPortfolios.creation_successful_msg', {name: '%name%'}),
          placeholders: [{name: "name", content: name}],
          type: 'success',
          options: {
            action: {
              text: 'Zum Portfolio',
              push: {name: 'portfolioDetail', params: {id: id}}
            }
          }
        })
        this.showDialogCreatePortfolio = false

      } catch (e) {
        console.error('Failed to create portfolio ' + name, e)
        this.$toasted.global.finToast({
          message: 'Dein Portfolio %name% konnte nicht erstellt werden.',
          placeholders: [{name: "name", content: name}],
          type: 'error'
        })
      }
      this.createPortfolioInProcess = false
    },
    importAndCreatePortfolio(form) {
      if (this.maxPortfolios && this.portfolioCount >= this.maxPortfolios) {
        this.showDialogImportPortfolio = false
        let newCount = this.portfolioCount
        EventBus.$emit('showSubscriptionPopup', PRICEMODEL_FEATURE_IDS.PORTFOLIO.id, PRICEMODEL_FEATURE_RESTRICTIONS.QUANTITY, {itemAmount: ++newCount})
      } else {
        this.createPortfolioInProcess = true
        this.currentStatus = STATUS_SAVING

        const path = `Import/${form.importData.name}`
        const name = form.name

        const _this = this
        this.messageDetails = []
        this.newPortfolioId = null
        this.customErrorMsg = null

        return new Promise((resolve, reject) => {
          Storage.put(path, form.importData, {
            level: 'private',
          }).then(result => {
            finPortfolioAPI.importPortfolio(path, name)
              .then(async data => {
                const messages = data.message

                messages.forEach(msg => this.messageDetails.push(msg.message))
                this.newPortfolioId = data.portfolio.id
                this.currentStatus = STATUS_SUCCESS


                // portfolio was created => reload list
                if (data.portfolio) {
                  this.portfolioCount++ // prevents upload of another portfolio until list is reloaded
                  this.$refs.portfolios.reload()

                  if (this.showOnBoarding) {
                    this.userOnboardingData.initialOnboardingFinished = true
                    const jsonVal = JSON.stringify(this.userOnboardingData) || '{}'
                    await this.updateOnboarding(jsonVal).catch(error => {
                      console.error("Error setting initialOnboardingFinished after importing first portfolio", error)
                    })
                  }
                }
              }).catch(err => {
              console.error("Couldn't import file via lambda", err)
              this.currentStatus = STATUS_FAILED
              if(!err.errors.length >= 1) {
                const error = handleError(ERROR_TYPE.COMMON, err.errors[0])
                this.customErrorMsg = error.msg
              } else {
                err.errors.forEach(err => this.messageDetails.push(err.message))
              }
            }).finally(() => _this.createPortfolioInProcess = false)
          })
        }).catch(err => {
          console.error("Couldn't upload portfolio file to S3", err)
          this.currentStatus = STATUS_FAILED
          this.createPortfolioInProcess = false
        })
      }
    },
    deletePortfolioConfirm(pfId, title) {
      this.$confirm({
        title: 'Portfolio löschen',
        text: `Möchtest du das Portfolio "${title}" wirklich löschen?`,
        dialogWidth: 350,
        confirmBtn: 'Ja'
      })
        .then(() => {
          this.deletePortfolio(pfId, title)
        }).catch(() => {
      })
    },
    async deletePortfolio(portfolioId, title) {
      console.log("MyPortfoliosWrapper.deletePortfolio", portfolioId)

      try {
        await finPortfolioAPI.deletePortfolioConfiguration({id: portfolioId})
        this.$toasted.global.finToast({
          message: 'Das Portfolio %name% wurde erfolgreich gelöscht.',
          placeholders: [{name: 'name', content: title}],
          type: 'success'
        })
        await this.$refs.portfolios.reload()
      } catch (error) {
        console.error('Error deleting portfolio', error, portfolioId)
        this.$toasted.global.finToast({
          message: `Beim Löschen deines Portfolios %name% ist ein Fehler aufgetreten. Bitte versuche es später erneut.`,
          placeholders: [{name: "name", content: title}],
          type: 'error'
        })
      }
    },
    changePortfolioStatusConfirm(pfId, title, newStatus) {
      const text = []
      if (!newStatus) {
        const hint = 'Warum ist dieses Portfolio gesperrt?'
        text.push({
          autoParse: false,
          type: "paragraph",
          text: hint,
          spans: [{
            "start": 0,
            "end": hint.length,
            "type": "crossref",
            "data": {"to": this.profile.stripeId ? "portfoliosperre-downgrade" : "portfoliosperre-paywall"}
          }]
        })
      }
      text.push({
        type: "paragraph",
        text: `Möchtest du das Portfolio "${title}" wirklich ` + (newStatus ? 'deaktivieren' : 'aktivieren') + '?',
        spans: [],
      })

      this.$confirm({
        title: 'Portfolio ' + (newStatus ? 'deaktivieren' : 'aktivieren'),
        text,
        dialogWidth: 400,
        confirmBtn: 'Ja',
        textWithLexikonLink: true,
      })
        .then(() => {
          this.changePortfolioStatus({newStatus, pfId})
        }).catch(() => {
      })
    },
    async changePortfolioStatus(statusObj) {
      console.log("MyPortfoliosWrapper.changePortfolioStatus", statusObj)

      try {
        await API.graphql(graphqlOperation(itemInactiveStatus, {
          featureId: PRICEMODEL_FEATURE_IDS.PORTFOLIO.id,
          itemId: statusObj.pfId,
          newStatus: statusObj.newStatus,
        }))

        await this.$refs.portfolios.reload()
      } catch (error) {
        if (error.errors.length === 1 && error.errors[0].errorType === 'ActiveItemCountExceededException') {
          this.$confirm({
            title: 'Hinweis',
            text: 'Dein Abo erlaubt dir derzeit die Nutzung von ' + this.maxPortfolios + ' Portfolio(s).\n\nUm dieses Portfolio aktiv zu nutzen, musst du andere Portfolios deaktivieren oder löschen.',
            dialogWidth: 400,
            textWithLexikonLink: true,
            cancelBtn: null,
          })
        } else {
          console.error('Error de/activating portfolio', error, statusObj)
          this.$toasted.global.finToast({
            message: `Beim ${statusObj.newStatus ? 'Deaktivieren' : 'Aktivieren'} deines Portfolios %id% ist ein Fehler aufgetreten.`,
            placeholders: [{name: "id", content: statusObj.pfId}],
            type: 'error'
          })
        }
      }
    },
    async exportPortfolio(pfId, pfTitle) {
      console.log("MyPortfoliosWrapper.exportPortfolio", pfId, pfTitle)
      if (this.isPriceModelFeatureEnabled(PRICEMODEL_FEATURE_IDS.PORTFOLIO_UPLOAD_DOWNLOAD.id) === false) {
        EventBus.$emit('showSubscriptionPopup', PRICEMODEL_FEATURE_IDS.PORTFOLIO_UPLOAD_DOWNLOAD.id, PRICEMODEL_FEATURE_RESTRICTIONS.UNAVAILABLE)
      } else {
        let exportURL = await API.graphql(graphqlOperation(exportPortfolio, {
          portfolioId: pfId,
          format: 'XLSX',
        }))

        if (exportURL.data.exportPortfolio) {
          const fileName = exportURL.data.exportPortfolio.substr(exportURL.data.exportPortfolio.indexOf('/Download') + 1)
          const signedURL = await this.$Amplify.Storage.get(fileName, {level: 'private'})

          if (signedURL) {
            const a = document.createElement("a")
            a.href = signedURL
            a.setAttribute('download', exportURL.data.exportPortfolio.substr(exportURL.data.exportPortfolio.lastIndexOf('/') + 1))
            a.target = '_blank'

            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
          }
        }
      }
    },
    tabChanged(tab) {
      this.selectedGroup = tab
      if (tab === 0) {
        this.pushToAmplitude({
          'event': 'fincraft_finhub_portfolios_performanceanalyzer',
          'step': 'goto_performanceanalyzer',
          'placement': 'fincraft_finhub_portfolios',
          'vue_breakpoint': this.$vuetify.breakpoint.name
        })
      }
    }
  },
  watch: {
    showDialogImportPortfolio() {
      this.customErrorMsg = null
      this.currentStatus = STATUS_INITIAL
      this.messageDetails = []
    }
  },
}
</script>


<style lang="scss" scoped>
.more {
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.14;
  letter-spacing: normal;
  text-align: center;
}

.portfolios-wrapper-tabs {
  ::v-deep .v-toolbar__content {
    box-shadow: none !important;
  }
}
</style>
